import generateCrudEndpoints from '@packages/toolbox/dist/utils/endpoint-generator';

import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/shared';

export const usefulLinksUrl = `${SERVER_API}/useful-links`;

export const USEFUL_LINKS_API = {
  ...generateCrudEndpoints(usefulLinksUrl),
  EXPORT: {
    method: 'POST',
    url: `${usefulLinksUrl}/export`,
  } as IEndpointData,
};
